export default class User {
    constructor(data = {}) {
        this.id = data.id || null;
        this.username = data.username || '';
        this.collectiveName = data.collectiveName || '';
        this.name = data.name || '';
        this.surname = data.surname || '';
        this.email = data.email || '';
        this.telephone = data.telephone || '';
        this.zipCode = data.zipCode || '';
        this.active = data.active || false;
        this.registerToken = data.registerToken || '';
        this.socialIdSap = data.socialIdSap || '';
        this.unsubscribeDate = data.unsubscribeDate || null;
        this.createdAt = data.createdAt || null;
        this.updatedAt = data.updatedAt || null;
    }

    static getUser(data) {
        return new User({
            id: data.id,
            username: data.username,
            collectiveName: data.collectiveName,
            name: data.name,
            surname: data.surname,
            email: data.email,
            telephone: data.telephone,
            zipCode: data.zipCode,
            active: data.active,
            registerToken: data.registerToken,
            socialIdSap: data.socialIdSap,
            unsubscribeDate: data.unsubscribeDate,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt
        });
    }
}
